import type { ComponentProps, ReactNode } from "react";
import { Link } from "expo-router";
import { Pressable, StyleSheet, Text } from "react-native";

import { fonts, useThemedStyles, type ThemeColors } from "~/styles/theme";

export function AppLink({
  children,
  size = "xs",
  tone = "default",
  ...props
}: ComponentProps<typeof Link> & {
  children: ReactNode;
  size?: "xs" | "sm" | "base";
  tone?: "default" | "inverse";
}) {
  const { stylesheet, sizeStyles } = useThemedStyles(makeStyles);
  return (
    <Link accessibilityRole="link" asChild {...props}>
      <Pressable>
        {({ hovered, pressed }) => (
          <Text
            style={[
              sizeStyles[size],
              tone === "inverse" ? stylesheet.inverse : stylesheet.default,
              hovered || pressed ? stylesheet.hover : null,
            ]}
          >
            {children}
          </Text>
        )}
      </Pressable>
    </Link>
  );
}

const makeStyles = (colors: ThemeColors) => {
  const stylesheet = StyleSheet.create({
    xs: { fontFamily: fonts.regular, fontSize: 12 },
    sm: { fontFamily: fonts.regular, fontSize: 14 },
    base: { fontFamily: fonts.regular, fontSize: 16 },
    default: { color: colors.primary },
    inverse: { color: "#FFFFFF" },
    hover: { textDecorationLine: "underline" as const },
  });
  const sizeStyles = {
    xs: stylesheet.xs,
    sm: stylesheet.sm,
    base: stylesheet.base,
  };
  return { stylesheet, sizeStyles };
};
